import React from 'react';

import { Link } from 'gatsby';
import { Card } from 'react-bootstrap';
import { FiBox } from 'react-icons/fi';

import imageUrlFor from 'helpers/image-url';

const Tool = ({ logo, name, description, path }) => {
  return (
    <Card as={Link} className="tool link-card" to={path}>
      <Card.Body>
        {logo ? (
          <img src={imageUrlFor(logo.asset.url).width(80).url()} alt="" className="logo" />
        ) : (
          <FiBox className="logo" />
        )}
        <h5 className="name">{name}</h5>
        <p className="description">{description}</p>
      </Card.Body>
    </Card>
  );
};

export default Tool;
